// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ContactInfoType } from './contactInfoType.js';
import type { SimpleIntakeOptInsModel } from './simpleIntakeOptInsModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SimpleIntakePreferencesModel {
    'optIns'?: SimpleIntakeOptInsModel | null;
    'preferred'?: ContactInfoType;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SimpleIntakePreferencesModel>> = [
        {
            "name":     "optIns",
            "baseName": "optIns",
            "type":     "SimpleIntakeOptInsModel"
        },
        {
            "name":     "preferred",
            "baseName": "preferred",
            "type":     "ContactInfoType"
        },
    ];

    static getAttributeTypeMap() {
        return SimpleIntakePreferencesModel.attributeTypeMap;
    }
}
